export const OverlayType = {
  POLYGON: 'polygon',
  POLYLINE: 'polyline',
  RECTANGLE: 'rectangle',
  CIRCLE: 'circle',
  MARKER: 'marker',
} as const;

export type OverlayTypeValue = typeof OverlayType[keyof typeof OverlayType];

export type OverlayGeometry =
  | google.maps.Marker
  | google.maps.Polygon
  | google.maps.Polyline
  | google.maps.Rectangle
  | google.maps.Circle;

export interface DrawResult {
  type: OverlayTypeValue;
  overlay: OverlayGeometry;
}

export interface Snapshot {
  radius?: number;
  center?: google.maps.LatLngLiteral;
  position?: google.maps.LatLngLiteral;
  path?: Array<google.maps.LatLng>;
  bounds?: google.maps.LatLngBoundsLiteral;
}

export interface Overlay {
  type: OverlayTypeValue;
  geometry: OverlayGeometry;
  snapshot: Snapshot;
}

export interface State {
  now?: Overlay;
}

export enum DrawingActionKind {
  SET_OVERLAY = 'SET_OVERLAY',
  UPDATE_OVERLAYS = 'UPDATE_OVERLAYS',
  CLEAR_OVERLAY = 'CLEAR_OVERLAY',
}

export interface ActionWithTypeOnly {
  type: Exclude<DrawingActionKind, DrawingActionKind.SET_OVERLAY>;
}

export interface SetOverlayAction {
  type: DrawingActionKind.SET_OVERLAY;
  payload: DrawResult;
}

export type Action = ActionWithTypeOnly | SetOverlayAction;

export function isPolygon(overlay: OverlayGeometry): overlay is google.maps.Polygon {
  return (overlay as google.maps.Polygon).getPath !== undefined;
}
